/**
   * Show an element by selector
   * @param {string} selector - CSS selector for the element to show
   */
function showElement(selector) {
    const element = document.querySelector(selector);
    if (element) {
        element.style.display = '';
        element.style.visibility = 'visible';
    }
}

/**
 * Hide an element by selector
 * @param {string} selector - CSS selector for the element to hide
 */
function hideElement(selector) {
    const element = document.querySelector(selector);
    if (element) {
        element.style.display = 'none';
    }
}

/**
 * Show multiple elements by comma-separated selectors
 * @param {string} selectorsString - Comma-separated CSS selectors for elements to show
 */
function showElements(selectorsString) {
    const selectors = selectorsString.split(',').map(s => s.trim());
    selectors.forEach(selector => {
        showElement(selector);
    });
}

/**
 * Hide multiple elements by comma-separated selectors
 * @param {string} selectorsString - Comma-separated CSS selectors for elements to hide
 */
function hideElements(selectorsString) {
    const selectors = selectorsString.split(',').map(s => s.trim());
    selectors.forEach(selector => {
        hideElement(selector);
    });
}